import { combineReducers } from 'redux';
import authReducer from './authReducer';
import queryReducer from './queryReducer';

export default combineReducers({
    authReducer,
    queryReducer
});